import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily?: string; showKeyboard?: boolean; inputControl?: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      membershipContainer: {
        background: 'white',
        height: '809px',
        borderRadius: '8px',
        overflow: 'hidden',
        width: '100%',
        boxShadow: '0 3px 9px 0px rgba(0,0,0,0.2)',
        [theme.breakpoints.down('lg')]: {
          height: '1640px',
          flexDirection: 'column-reverse'
        }
      },
      subHeading: {
        fontSize: '25px',
        [theme.breakpoints.down('lg')]: {
          fontSize: '30px'
        }
      },
      imageContainer: {
        [theme.breakpoints.down('lg')]: {
          marginBottom: '40px'
        }
      },
      scanTextContainer: {
        [theme.breakpoints.down('lg')]: {
          padding: '40px 134px 60px 134px',
          height: '55%'
        },
        margin: 0,
        padding: '120px 60px 60px 160px',
        background: 'transparent'
      },
      lookupViewTitle: {
        width: '910px',
        margin: '0px 0px 24px 0px',
        background: 'transparent',
        [theme.breakpoints.down('lg')]: {
          width: '700px'
        }
      },
      footerContainer: {
        margin: '20px -26px 0',
        width: 'calc(100% + 52px)'
      },
      customSearchOuterContainer: {
        height: '809px',
        padding: '0 24px 24px',
        [theme.breakpoints.down('lg')]: {
          height: '1660px'
        }
      },
      customSearchInnerContainer: {
        background: 'white',
        padding: '30px 64px',
        [theme.breakpoints.down('lg')]: {
          height: '1600px',
          padding: '98px 30px 48px 30px'
        }
      },
      customSearchInputsBox: {
        flex: '1 1 0%',
        background: 'transparent',
        [theme.breakpoints.down('lg')]: {
          height: '1000px'
        }
      },
      customSearchInputsContainer: {
        padding: '0px 80px 0px 80px',
        height: props.inputControl ? '220px' : '525px',
        [theme.breakpoints.down('lg')]: {
          height: '100%',
          padding: '0px 0px 0px 0px'
        }
      },
      customSearchInputField: {
        [theme.breakpoints.down('lg')]: {
          minWidth: '350px !important',
          fontSize: '30px'
        }
      },
      customSearchInputLabel: {
        fontWeight: 600,
        fontSize: '32px',
        margin: '0px',
        [theme.breakpoints.down('lg')]: {
          fontSize: '30px'
        }
      }
    })
  );
